import { View, Text } from '@react-pdf/renderer';
import { Span } from '..';
import { en } from '../../theme/languages/en';
import { CryptoSettings } from '../../../common/interfaces/invoice.interface';
import { CryptoTokens } from '../../../common/enums';
import { svgImg } from '../../icons/svgIcons';
import { styles } from './CryptoPaymentData.module';

interface CryptoPaymentDataProps {
  data?: CryptoSettings;
}
export const CryptoPaymentData = ({ data }: CryptoPaymentDataProps) => {
  const getImageSrcByName = (name: CryptoTokens) => {
    switch (name) {
      case CryptoTokens.USDC:
        return svgImg('usdc');
      case CryptoTokens.USDT:
        return svgImg('usdt');
      default:
        return '';
    }
  };

  return (
    <View style={styles.bottomContainer} wrap={false}>
      <View style={styles.titleContainer}>
        <Span style={[styles.text, styles.title]}>{en.payWithCrypto}</Span>

        <View style={styles.tokenContainer}>
          {data?.tokens?.map((token, index) => {
            return (
              <View style={styles.token} key={index}>
                {getImageSrcByName(token)}
                <Text style={styles.tokenText}>{token}</Text>
              </View>
            );
          })}
        </View>
      </View>

      <View style={styles.cryptoContainer}>
        <Text style={styles.text} wrap={false}>
          {en.sendToAddress}: {data?.address}
        </Text>
      </View>
    </View>
  );
};
